export enum MediaType {
  Video,
  Image,
  Audio,
  Unsupported,
  PDF,
}

export function contentTypeToMediaType(contentType?: string | null): MediaType {
  const normalized = contentType?.trim().toLowerCase();

  if (!normalized) {
    return MediaType.Unsupported;
  }

  if (normalized === "application/pdf" || normalized === "application/x-pdf") {
    return MediaType.PDF;
  }

  if (normalized.startsWith("video/")) {
    return MediaType.Video;
  }

  if (normalized.startsWith("image/")) {
    return MediaType.Image;
  }

  if (normalized.startsWith("audio/")) {
    return MediaType.Audio;
  }

  return MediaType.Unsupported;
}

/**
 * The two rendering kinds a deliverable surface carries for its media — a
 * video plays, an image shows — as the string vocabulary the review-panel
 * tile stores and the editor preview derives from a format's length.
 * `MediaType` above is the player's classification of a FILE (audio, PDF and
 * unsupported included); `MediaKind` is the subset a surface renders, so a
 * PDF tile, which shows its page count instead, carries none.
 */
export const MediaKind = {
  Video: "Video",
  Image: "Image",
} as const;
export type MediaKind = (typeof MediaKind)[keyof typeof MediaKind];

/** The rendering kind of a classified file — undefined when it renders as neither. */
export function mediaKindOf(mediaType: MediaType): MediaKind | undefined {
  switch (mediaType) {
    case MediaType.Video:
      return MediaKind.Video;
    case MediaType.Image:
      return MediaKind.Image;
    default:
      return undefined;
  }
}
